import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import RecipesCard from "../../recipes/listing/recipesCard";
import Loader from "../../../../sharedComponents/preloader";
import { getRecipes } from "../../../../store/actions";
import { objToQueryString, queryStringToJSON } from "../../../../utils/common";
import KeywordSearch from "../../../../sharedComponents/keywordSearch";
import NoRecipeFound from "../../../../sharedComponents/noItemFoundAlert";

const SelectRecipe = ({
	recipeList,
	setSelectedRecipe,
	selectedRecipe,
	history,
	atBottom,
	setAtBottom,
	next,
	getRecipes,
	setIsRecipe,
	setIsFoodItem,
	setToggleAddToJornal
}) => {
	const [showLoader, setShowLoader] = useState(true);
	const [fetching, setFetching] = useState(false);
	const [recipes, setRecipes] = useState([]);

	const [filters, setFilters] = useState({
		ordering: "id",
		limit: 8,
		search: "",
		active: "True",
		declined: "True"
	});
	const [query, setQuery] = useState();

	useEffect(() => {
		const newFilters = { ...filters };
		setQuery(objToQueryString(newFilters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setRecipes([]);
			setShowLoader(true);
			getRecipes(query);
		}
	}, [query, getRecipes]);

	useEffect(() => {
		if (atBottom) {
			setFetching(next ? true : false);
		}
	}, [atBottom, next]);

	useEffect(() => {
		setRecipes((prevState) => [...prevState, ...(recipeList !== null ? recipeList : [])]);
		setAtBottom(false);
	}, [recipeList, setAtBottom]);

	useEffect(() => {
		recipes && recipes.length && setShowLoader(false);
	}, [recipes]);

	useEffect(() => {
		fetching && getRecipes(next.split("?")[1]);
		fetching && setShowLoader(true);
		setFetching(false);
	}, [fetching, getRecipes, next]);

	useEffect(() => {
		return () => {
			setRecipes([]);
		};
	}, [setRecipes]);

	const cancel = () => {
		setSelectedRecipe(null);
		setIsRecipe(false);
		setIsFoodItem(false);
		setToggleAddToJornal(false);
	};

	return (
		<React.Fragment>
			<div className="mb-3">
				<KeywordSearch
					placeholder="Search Recipes"
					searchField="search"
					searchAction={(event) => setFilters({ ...filters, ...queryStringToJSON("?" + event) })}
					name="searchRecipe"
					className="mr-2"
					reset={false}
				/>
			</div>
			<div className="row card-wrap select-recipe-wrap flex-fill">
				{recipes && recipes.length
					? recipes.map((card, i) => (
							<div className="col-6 mb-3" key={card.id}>
								<button
									type="button"
									className="btn btn-light btn-cell btn-sm"
									onClick={() => setSelectedRecipe(card)}>
									{selectedRecipe && selectedRecipe.id === card.id ? (
										<i className="icon icon-check" />
									) : (
										<i className="icon icon-plus" />
									)}
								</button>
								<RecipesCard key={i} history={history} cardInfo={card} />
							</div>
					  ))
					: null}
				{!recipeList && <Loader show={showLoader} />}
				{recipeList && recipeList.length === 0 ? (
					<div className="px-3 w-100">
						<NoRecipeFound message="No recipe found!" />
					</div>
				) : null}
			</div>
			<div className="filter-footer sticky-footer text-right px-0">
				<button onClick={cancel} className="btn btn-default">
					Cancel
				</button>
			</div>
		</React.Fragment>
	);
};

const mapDispatchToProps = { getRecipes };

const mapStateToProps = (state) => {
	const { Recipes } = state;
	return {
		recipeList: get(Recipes, "recipesResult.results", null),
		next: get(Recipes, "recipesResult.next")
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SelectRecipe);
